import { openTab } from '@intelligence/utils/commonUtils';
import { pageReportTypeConfig } from '@intelligence/_config/reportConfig';

import type { IPDFPreviewDownloadURLSearchParams } from '@intelligence/pages/PDFPreviewDownload/types';

interface IReportPreviewFileSource {
  file_name?: string;
  pdf?: string;
}

/** 从 COS path / 文件名中取出末段，供短链判断 html/zip */
const getReportFileNameFromPath = (path?: string): string => {
  const purePath = (path || '').split(/[?#]/)[0];
  if (!purePath) {
    return '';
  }
  return purePath.substring(purePath.lastIndexOf('/') + 1);
};

/**
 * 从 COS path / 报告字段取出预览用文件名，供短链判断 html/zip
 */
export const getReportPreviewFileName = (
  resourcePath?: string,
  report?: IReportPreviewFileSource,
): string => {
  return (
    getReportFileNameFromPath(resourcePath)
    || getReportFileNameFromPath(report?.file_name)
    || getReportFileNameFromPath(report?.pdf)
  );
};

const URL_PARAM_WHITELIST: Set<string> = new Set([
  'systemId',
  'resourceId',
  'lang',
  'referer',
  'studioId',
]);

// 仅 studio_report 写入短链：浏览量要管理端 id；fileName 只用来判断 html/zip
const STUDIO_ONLY_URL_PARAMS: Set<string> = new Set(['id', 'fileName']);

export const openPDFPreviewDownloadPage = (path: string, params: IPDFPreviewDownloadURLSearchParams) => {
  const urlSearchParams = new URLSearchParams();
  const isStudioReport =
    params.systemId === pageReportTypeConfig.studioReport.systemIdCur;
  Object.entries(params).forEach(([param, value]) => {
    const allowed =
      URL_PARAM_WHITELIST.has(param)
      || (isStudioReport && STUDIO_ONLY_URL_PARAMS.has(param));
    if (allowed && value !== null && value !== undefined && value !== '') {
      urlSearchParams.set(param, value);
    }
  });
  const urlSearchParamsStr = urlSearchParams.toString();
  openTab(`${path}?${urlSearchParamsStr}`);
};
